/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowCircularLeft12: {
  name: 'arrow-circular-left-12';
  data: string;
} = {
  name: 'arrow-circular-left-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M3.049 1.964a5 5 0 1 1-1.686 5.91 2.5 2.5 0 0 0 .358-.006l1.812-.16a3 3 0 1 0 .959-4.3l1.27 1.27a.5.5 0 0 1-.309.851l-3.909.347a.5.5 0 0 1-.542-.547l.378-3.878a.5.5 0 0 1 .852-.305z" fill-rule="evenodd"/></svg>`
};
